import $ from '@vaersaagod/tools/Dom';
import agent from '@vaersaagod/tools/request';
import Dispatch from '@vaersaagod/tools/Dispatch';
import { POEMS_LOADED } from '../lib/events';

export default (el, props) => {
    const dom = $(el);
    const list = dom.find('[data-list]');
    const button = dom.find('[data-load]');

    let request = null;

    const cancel = () => {
        if (request) {
            request.abort();
            request = null;
        }
    };

    const load = e => {
        e.preventDefault();
        cancel();
        request = agent.get(button.attr('href'));
        request.then(res => {
            const response = $(res.text);
            const poems = response.find('[data-reveal]');
            const url = response.find('[data-load]').attr('href') || false;
            list.append(poems);
            if (url) {
                button.attr('href', url);
            } else {
                button.parent().remove();
            }
            poems.first().find('a').focus();
            Dispatch.emit(POEMS_LOADED, poems);
        }, error => {
            console.error(error);
        });
    };

    const init = () => {
        button.on('click', load);
    };

    const destroy = () => {
        button.off('click', load);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/PoemsList.js